import { TTheme } from '@core/theme'
import { styled } from '@mui/system'

export const InfoItemWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;

    .title {
        color: ${({ theme: { colors } }) => colors.greys[500]};
    }

    .content {
        color: ${({ theme: { colors } }) => colors.greys[800]};
        word-break: break-word;
    }
`
